export default "__VITE_ASSET__Cc_g3LSI__"